module.exports = __webpack_public_path__ + "img/icon-stockpicker-generating@3x.07ab1cbb.png";